import { api } from 'domains/api';
import { BASE_ANONYMOUS_API_ROUTES, getBaseAPIRoute } from 'domains/api/base/routes';
import { normalizeResumeLeadData } from 'domains/signupDirect/ResumeLead/data/normalizeData';
import { IncompleteLeadIDResponse } from 'domains/signupDirect/ResumeLead/data/types';

export type SignupResumeLeadPayload = {
  /** In 04-04-2004 format */
  dateOfBirth: string;
  clientFirstName: string;
  clientLastName: string;
};

/**
 * Will gather all saved lead data but ONLY if the provided values match exactly
 * LeadID + DOB + First Name + Last Name must match exactly, otherwise no data will be returned
 */
export const getIncompleteLeadData = (leadID: string, data: SignupResumeLeadPayload) => {
  return api.baseAnonymous
    .post<IncompleteLeadIDResponse>(
      getBaseAPIRoute(BASE_ANONYMOUS_API_ROUTES.signup.lead[':leadID'], {
        leadID,
      }),
      data,
    )
    .then(d => normalizeResumeLeadData(d));
};
